export default __webpack_public_path__ + "static/media/image12.ae78aa21.jpg";